// 04 — who's in. Everything here — the count, the grid, the names — is behind
// the sign-in. The public side shows nothing personal, not even the aggregate.
import { Icon } from '../lib/icons';
import { MONO, Section, SectionHead } from './primitives';

export function SectionWhosIn({
  headsIn,
  invited,
  signedIn,
  rosterNames,
  waitingCount,
}: {
  headsIn: number;
  invited: number;
  signedIn: boolean;
  rosterNames: string;
  waitingCount: number;
}) {
  const seats = Array.from({ length: invited }, (_, i) => i < headsIn);

  return (
    <Section label="04 who's in">
      <SectionHead numeral="04 — who's in" title="the count" />

      {signedIn ? (
        <>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
            <div
              style={{
                fontFamily: MONO,
                fontSize: 'clamp(56px,15vw,76px)',
                fontWeight: 700,
                lineHeight: 0.9,
                color: 'var(--cyan)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {headsIn}
            </div>
            <div style={{ fontSize: 21, color: 'var(--cyan-soft)' }}>of {invited} have said yes so far</div>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              gap: 8,
              marginTop: 20,
              maxWidth: 320,
            }}
          >
            {seats.map((filled, i) => (
              <div
                key={i}
                style={{
                  aspectRatio: '1',
                  borderRadius: 12,
                  display: 'grid',
                  placeItems: 'center',
                  background: filled ? 'var(--cyan)' : 'transparent',
                  color: filled ? 'var(--deep)' : 'rgba(234,247,248,0.3)',
                  border: `2px solid ${filled ? 'var(--cyan)' : 'rgba(234,247,248,0.22)'}`,
                }}
              >
                <Icon name="user" size={26} />
              </div>
            ))}
          </div>

          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: 20, lineHeight: 1.7, color: 'var(--bone)' }}>{rosterNames}</div>
            <div style={{ fontFamily: MONO, fontSize: 14, color: 'var(--muted)', marginTop: 12 }}>
              still waiting on {waitingCount} households.
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            background: 'var(--deeper)',
            border: '1px solid rgba(127,227,232,0.24)',
            borderRadius: 12,
            padding: 18,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Icon name="lock" size={28} color="var(--cyan)" style={{ flex: 'none' }} />
            <div style={{ fontSize: 19, lineHeight: 1.5, color: 'var(--body-2)' }}>
              the count and who's coming are behind the sign-in — nothing personal is on the public side.
            </div>
          </div>
          <a
            href="#respond"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              minHeight: 52,
              fontSize: 19,
              fontWeight: 700,
              color: 'var(--cyan)',
              marginTop: 6,
            }}
          >
            sign in to see who's coming →
          </a>
        </div>
      )}
    </Section>
  );
}
